import React from "react";
import { useState ,useContext} from "react";
import {
  formatIndianAmount,
  formatDaysAgo,
  getDisplayPrice,
  addtoWishlist,
  getWishList,
} from "../Services/Helper";
import { useNavigate } from "react-router-dom";
import { ApiContext } from "../Context/Context";
import { LoggedInUserID } from "../Services/Urls";

const FeaturedProperties =  ({ onheartClick, ...data }) => {
  const {
    logindata,
    setlogindata,
    userData,
    setuserData,
    coordinates,
    setcoordinates,

    searchData,
    setsearchData,wishlist, setWishlist
  } = useContext(ApiContext);
  const navigate = useNavigate();
  const defaultImage = "assets/img/property/property-22.jpg";
  const [openLogin, setOpenLogin] = useState(false);
  const imageSrc =
    typeof data?.Images === "string" && data.Images.trim() !== ""
      ? data.Images.split(",")[0].trim()
      : defaultImage;

  const handleNavigate = () => {
    const tabID =
      data?.PropertyTypeID === 1 && data?.VerticalID === 1
        ? 384
        : data?.PropertyTypeID === 1 && data?.VerticalID === 2
          ? 385
          : data?.PropertyTypeID === 1 && data?.VerticalID === 3
            ? 386
            : data?.PropertyTypeID === 2 && data?.VerticalID === 1
              ? 387
              : 388;

    navigate(`/property-details?id=${data?.ListingID}`, {
      state: {
        TabID: tabID,
      },
    });
  };

 // const [wishlist, setWishlist] = useState(getWishList() || []);

  const isWishlisted = (data) => {
    return wishlist.some(
      (item) =>
        item.ListingID === data?.ListingID &&
        item.VerticalID === data?.VerticalID &&
        item.PropertyTypeID === data?.PropertyTypeID,
    );
  };

  return (
    <div
      //  onClick={handleNavigate}
      className="col-lg-12 col-md-12 col-sm-12 col-xs-12"
    >
      <div
        className="property-card style4 d-flex listpro prolist"
        data-aos="fade-up"
        data-aos-duration={1200}
        data-aos-delay={400}
      >
        <div className="property-img" style={{ width: "35%" }}>
          <img src={imageSrc} alt="Property" />

          <div className="chipps chippss">
            {data.FeaturedID === 1 && (
              <span className="property-condo">Featured</span>
            )}
            <span className="property-status">
              <i
                onClick={(e) => {
                  e.stopPropagation(); // prevents parent click

                  if(LoggedInUserID == null){
                    onheartClick();

                  }else{
 addtoWishlist(data, wishlist, setWishlist);
                  }
                 
                }}
                style={{
                  color: isWishlisted(data) ? "red" : "#ccc",
                }}
                className="ri-heart-fill"
              />
            </span>
          </div>
        </div>
        <div className="property-info" style={{ width: "65%" }}>
          <h3>
            <a>{data.Title}</a>
          </h3>
          <p>
            <i className="flaticon-location" />
            {data.Locality}
          </p>
          <p className="property-price" style={{ margin: "5px 3px" }}>
            {getDisplayPrice(data)}
          </p>
          <div className="headss">
            <ul
              className="property-metainfo list-style lst1"
              style={{ marginTop: 10, whiteSpace: "nowrap" }}
            >
              {Array.isArray(data?.UnitFurnishingtitle) &&
                data?.UnitFurnishingtitle?.length > 0 &&
                data?.UnitFurnishingtitle?.slice(0, 3)?.map((title, index) => (
                  <li key={index}>
                    <img
                      src={title?.UnitFurnishingIcon}
                      alt="Furniture"
                      style={{ height: 20, width: 20 }}
                      // className="furnishing-icon"
                    />
                    {title?.Quantity}
                  </li>
                ))}
            </ul>
          </div>
          <div className="filterownerchip">
            {/* <div className="agent d-flex">
                <div className="chipsn"> <i className="ri-shield-check-line"></i> Agent</div>
                <span>Ravi Mehta</span>
            </div>
            
             <div className="owner d-flex">
                <div className="chipsn"> <i className="ri-shield-check-line"></i> Owner</div>
                <span>Ravi Mehta</span>
            </div> */}

            <div className="builder d-flex">
              <div className="chipsn">
                {" "}
                <i className="ri-shield-check-line"></i> {data?.PostedBy}
              </div>
              <span>{data?.SellerName}</span>
            </div>
          </div>

          <div className="d-flexx border-top pdt-10 detailblockks">
            <div className="d-desk">
              <div
                className="d-flex"
                style={{ alignItems: "center", whiteSpace: "nowrap" }}
              >
                <small className="">
                  {formatDaysAgo(data?.cDt?.split("T")[0])}
                </small>
                {/* <div className="chipps chp">
                    <span className="bg-red">FEATURED DEVELOPER</span>
                  </div> */}
              </div>

              {/* <small style={{marginLeft : 2}} className="developer devs">
                  by ABC Developer
                </small> */}
            </div>

            <div
              style={{ textAlign: "right", display: "flex" }}
              className="alignbtn"
            >
              {/* <a className="btn style1">View Number</a> */}

              <a onClick={handleNavigate} className="btn style3">
                View Details
              </a>
              {/* <button type="" className="btn style3">
                  {" "}
                  Download
                </button> */}
              {/* <button type="" className="btn style3">
                  <i className="ri-heart-line" />
                </button> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturedProperties;
